export default __webpack_public_path__ + "b331383f3d5acf6ee7d94360fb92204c.woff2";